module.exports = __webpack_public_path__ + "static/assets/16d9f2429541edede9938a9e96c43f31.png";